import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=08e64f0e&scoped=true&"
import script from "./reservation.vue?vue&type=script&lang=js&"
export * from "./reservation.vue?vue&type=script&lang=js&"
import style0 from "./reservation.vue?vue&type=style&index=0&id=08e64f0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e64f0e",
  null
  
)

component.options.__file = "reservation.vue"
export default component.exports